/**
 * Die Frist liegt nie vor der TWV (T-331, 15.10.2026): Wird die TWV gesetzt,
 * rückt eine leere oder frühere Frist auf die TWV nach — wie Beginn und Ende
 * eines Kalendertermins. Eine spätere Frist bleibt stehen. Dieselbe Regel gilt
 * im Server (`apps/api/src/vorgang/frist-folgt-twv.ts`); hier, damit die neue
 * Frist sofort zu sehen ist.
 */
export function fristZurTwv(twv: string | null | undefined, frist: string | null | undefined): string | null {
    const t = tag(twv);
    const f = tag(frist);
    if (!t) return frist ?? null;
    return !f || f < t ? t : (frist ?? null);
}

/** Patch für eine TWV-Änderung — mit Frist, wenn sie nachrücken muss. */
export function twvPatch(
    twv: string | null,
    fristVorher: string | null | undefined,
): { twv: string | null; frist?: string | null } {
    const frist = fristZurTwv(twv, fristVorher);
    return frist !== (fristVorher ?? null) ? { twv, frist } : { twv };
}

function tag(v: string | null | undefined): string | null {
    const s = String(v ?? "").trim();
    return /^\d{4}-\d{2}-\d{2}/.test(s) ? s.slice(0, 10) : null;
}
